import { keyframes } from 'styled-components'

export const notifyFadeOutAnim = keyframes`
    0% {
      opacity: 1;
      height: 24px;
    }
    100% {
      opacity: 0;
      height: 0px;
    }
  `
export const notifyFadeInAnim = keyframes`
    0% {
      opacity: 0;
      height: 0px;
    }
    100% {
      opacity: 1;
      height: 24px;
    }
`
export const diceRotateAnim = keyframes`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
`
export const widthChangeAnim = keyframes`
  0% {
      transform: scaleX(0);
  }
  100% {
      transform: scaleX(1);
  }

`
export const trainApearAnim = keyframes`
    0% {
      opacity: 0;
      width: 0;
    }
    100% {
      opacity: 1;
      width: 36px;
    }
`
export const trainRemoveAnim = keyframes`
    0% {
      width: 36px;
    }
    100% {
      width: 0;
      opacity: 0;
    }
`
export const addRowAnim = keyframes`
    0% {
      height: 0px;
    }
    100% {
      height: 33px;
    }
`
